import { useSnackbar as useClaraSnackbar } from '@clara/ui'

type OptionsObject = {
  variant: 'error' | 'warning' | 'info' | 'success'
}

export const useSnackbar = () => {
  const snackbar = useClaraSnackbar()
  const showSnackbar = (message: string, { variant }: OptionsObject) =>
    snackbar({
      message,
      position: 'bottom-left',
      status: variant,
      duration: 5000,
    })
  return showSnackbar
}
